import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class GooglePubSubWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.google_pubsub.ID;
        this.name = DatabaseEnum.google_pubsub.NAME;
        this.code = DatabaseEnum.google_pubsub.CODE;
        this.equivalentTag = DatabaseEnum.google_pubsub.EQUIVALENT_TAG;
        this.showLoadPropertiesTab = false;
        this.showExtractPropertiesTab = false;
        this.hideSchemaNmColumn = false;
        this.showDatabaseTab = false;
        this.isShowObjProperties = true;
        this.dataObjectConnDatabaseNm = 'Dataset';
        this.isFileType = true;
        this.showPropertiesTab = false;
        this.importFileProperties();
        this.showDataDescription = false;

    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {

        if (repConnWrapper.repConn.conn.host == "") {
            repConnWrapper.inValid_Cds.push('PROJ_ID');
        }

        if (repConnWrapper.repConn.conn.secAuth == "Service Account") {
            if (repConnWrapper.repConn.conn.fileloc == "") {
                repConnWrapper.inValid_Cds.push('FILE_LOC');
            }
        }

        if (repConnWrapper.repConn.conn.secAuth == "Access Token" && repConnWrapper.repConn.conn.access_Token_Flg != 'Y') {
            if (repConnWrapper.repConn.conn.accessToken == "") {
                repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
            }
        }

        if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y' && repConnWrapper.repConn.conn.secAuth != "Service Account") {
            if (repConnWrapper.repConn.conn.wrhloc == "") {
                repConnWrapper.inValid_Cds.push('EXT_SERVICE_CMD');
            }
            else if (repConnWrapper.repConn.conn.queueNm == "") {
                repConnWrapper.inValid_Cds.push('ACCESS_TOKEN_KEYNM');
            }
        }

        if (repConnWrapper.repConn.conn.topic == '') {
            repConnWrapper.inValid_Cds.push('TOPIC');
        }

        if (repConnWrapper.repConn.conn.proxy_Flg == 'Y') {
            if (repConnWrapper.repConn.conn.hdfshost == "") {
                repConnWrapper.inValid_Cds.push('PROXY_HOST');
            } else if (repConnWrapper.repConn.conn.hdfsport == "") {
                repConnWrapper.inValid_Cds.push('PROXY_PORT');
            } else if (repConnWrapper.repConn.conn.protocol == "") {
                repConnWrapper.inValid_Cds.push('PROTOCOL');
            }
        }
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }

        /*if( repConnWrapper.repConn.conn_Dbs.length < 1 ) {
            repConnWrapper.inValid_Cds.push('NO_DATASET');
        }*/
    }

    getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(),isHiveNative: boolean = false): Array<any> {
        return [
           this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
            this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getOrgKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component),
            this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
            this.attributeTabulator.getAttrExprVal(objectWrapper, component),
            this.attributeTabulator.getValid_Cd(objectWrapper,component),
        ]
    }

    getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
        return [
           this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getNotNullFlag(objectWrapper),
            //this.attributeTabulator.getRepeatedFlag(objectWrapper),
            this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
            this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getOrgKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper,component),
            this.attributeTabulator.getDescription(objectWrapper),
        ]
    }

    getSourceAttributeColumns(objectWrapper: ObjectWrapper, isShowExplodeColumn: boolean = false,
        isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false,component:any): Array<any> {
        return [
            this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.attributeTabulator.getSrt_Order(),
            this.attributeTabulator.getAttr_Id(),
            this.attributeTabulator.getClevel(objectWrapper, isShowExplodeColumn),
            this.attributeTabulator.getAttrNm(objectWrapper,component),
            this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
            this.attributeTabulator.getExplodeFlag(objectWrapper, isShowExplodeColumn),
            this.attributeTabulator.getAttrPrec(objectWrapper),
            this.attributeTabulator.getAttrScale(objectWrapper),
            this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
            this.attributeTabulator.getDistKeyFlag(objectWrapper),
            this.attributeTabulator.getOrgKeyFlag(objectWrapper),
            this.attributeTabulator.getOrderBy(objectWrapper, component),
            this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
            this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
            this.attributeTabulator.getValid_Cd(objectWrapper,component),
        ]
    }

    // getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
    //     return [
    //         this.attributeTabulator.getCheckBoxColumn(objectWrapper),
    //         this.lAttributeTabulator.getSrt_Order(),
    //         this.lAttributeTabulator.getLAttr_Id(),
    //         this.lAttributeTabulator.getLAttrNm(objectWrapper),
    //         this.lAttributeTabulator.getSelectColumn(objectWrapper),
    //         this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
    //         this.lAttributeTabulator.getLAttrPrec(objectWrapper),
    //         this.lAttributeTabulator.getLAttrScale(objectWrapper),
    //         this.lAttributeTabulator.getLAttrType( objectWrapper ),
    //         this.lAttributeTabulator.getLAttrFunction( objectWrapper),
    //         this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
    //         this.lAttributeTabulator.getPartFlag(objectWrapper),
    //         this.lAttributeTabulator.getOrderBy(objectWrapper)
    //     ]
    // }

    getLAttributeColumns(objectWrapper: ObjectWrapper,component): Array<any> {
        return [
           this.attributeTabulator.getCheckBoxColumn(objectWrapper),
            this.lAttributeTabulator.getSrt_Order(),
            this.lAttributeTabulator.getLAttr_Id(),
            this.lAttributeTabulator.getLAttrNm(objectWrapper),
            this.lAttributeTabulator.getSelectColumn(objectWrapper),
            this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
            this.lAttributeTabulator.getLAttrPrec(objectWrapper),
            this.lAttributeTabulator.getLAttrScale(objectWrapper),
            this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
            this.lAttributeTabulator.getDistKeyFlag(objectWrapper,component),
            this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
            this.lAttributeTabulator.getOrderBy(objectWrapper,component),
        ]
    }


    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showDelimiter = true;
        this.showFixedWidth = false;

    }

    readFileCutOffLength(type: string): number {
        if( type == "FILE" ){
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }
}
